module.exports = __webpack_public_path__ + "static/media/img_personal.54e0e1ec.svg";